const isDevelopment = process.env.NODE_ENV === 'development';

// Simple logger without stack trace complexity
const logger = {
  log: (...args) => isDevelopment && console.log(...args),
  info: (...args) => isDevelopment && console.info(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
  debug: (...args) => isDevelopment && console.debug(...args),
  group: (...args) => isDevelopment && console.group(...args),
  groupEnd: () => isDevelopment && console.groupEnd(),
  trace: (...args) => isDevelopment && console.trace(...args),

  // Category-based logging - accepts category as first parameter
  category: (category, ...args) => isDevelopment && console.log(`[${category.toUpperCase()}]`, ...args),
  
  // Create a logger instance for a specific category
  create: (category) => ({
    log: (...args) => isDevelopment && console.log(`[${category.toUpperCase()}]`, ...args),
    info: (...args) => isDevelopment && console.info(`[${category.toUpperCase()}]`, ...args),
    warn: (...args) => console.warn(`[${category.toUpperCase()}]`, ...args),
    error: (...args) => console.error(`[${category.toUpperCase()}]`, ...args),
    debug: (...args) => isDevelopment && console.debug(`[${category.toUpperCase()}]`, ...args),
  }),
};

export default logger;